export const UPDATE_IMPUESTOS_SELECCIONADOS = 'UPDATE_IMPUESTOS_SELECCIONADOS'